/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fact_Focus_ValueInputs */

const en_about_fact_focus_value = /** @type {(inputs: About_Fact_Focus_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI systems engineering`)
};

const lv_about_fact_focus_value = /** @type {(inputs: About_Fact_Focus_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sistēmu inženierija`)
};

/**
* | output |
* | --- |
* | "AI systems engineering" |
*
* @param {About_Fact_Focus_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_fact_focus_value = /** @type {((inputs?: About_Fact_Focus_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fact_Focus_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_fact_focus_value(inputs)
	return en_about_fact_focus_value(inputs)
});